// 项目默认配置项
export default {
    primaryColor: '#52C41A', // primary color of ant design
    navTheme: 'light', // theme for nav menu
    multiTab: false,
    localStorageOptions: {
        namespace: 'ecp__',
        name: 'ls',
        storage: 'local',
    },
    sessionStorageOptions: {
        namespace: 'ecp__',
        name: 'ss',
        storage: 'session',
    }
}